




































import { Inject, Component, Vue } from 'vue-property-decorator'
import { CompanyAPI, CustomerPortalBrandingAPI } from '@/api/backend-client'
import { CustomerPortalBranding } from '@/api/model/customer-portal-branding'

@Component
export default class CompanySettingsTypeformGeneral extends Vue {
    @Inject() readonly reloadCompany: () => Promise<void>
    branding: CustomerPortalBranding = null
    loading: boolean = false

    async created(): Promise<void> {
        await this.loadData()
    }

    async loadData(): Promise<void> {
        if (!this.$currentCompany.customerPortalBranding) {
            this.$currentCompany.customerPortalBranding = CustomerPortalBranding.new(
                this.$currentCompany,
            )

            await CustomerPortalBrandingAPI.create(this.$currentCompany.customerPortalBranding)
            await CompanyAPI.update(this.$currentCompany.id, this.$currentCompany)
        }

        this.branding = this.$currentCompany.customerPortalBranding
    }

    async save(): Promise<void> {
        this.loading = true
        this.branding = await CustomerPortalBrandingAPI.update(this.branding.id, this.branding)
        this.loading = false
        window.location.reload()
    }
}
